import React from "react";
import AdminLayout from "../AdminLayout";
import DashboardSection from "./dashboardSection";

const Dashboard = () => {
  return (
    <AdminLayout
      selectedMenuItem="Dashboard"
      pageTitle="Dashboard Overview"
      pageSubtitle="Monitor experts, inquiries, subscribers, and technology demand from one clean workspace."
      contentClassName="admin-dashboard-shell"
    >
      <DashboardSection />
    </AdminLayout>
  );
};

export default Dashboard;
